import {
  GET_BILL_HISTORY_SUCCESS,
  GET_BILL_HISTORY_FAIL,
  SET_GET_BILL_HISTORY_LOADING,
  GET_SINGLE_BILL_DATA_SUCCESS,
  GET_SINGLE_BILL_DATA_FAIL,
  SET_GET_SINGLE_BILL_DATA_LOADING,
} from '../actions/types';

const initialState = {
  billHistoryData: [],
  totalRecords: 0,
  currentPage: 1,
  itemsPerPage: 10,
  totalPages: 0,
  hasNextPage: false,
  hasPreviousPage: false,
  startRecord: 0,
  endRecord: 0,
  isGetBillHistoryLoading: false,
  isGetBillHistorySuccess: false,
  isGetBillHistoryError: false,
  getBillHistoryError: null,
  singleBillData: null,
  isSingleBillDataLoading: false,
  isSingleBillDataSuccess: false,
  isSingleBillDataError: false,
  getSingleBillDataError: null,
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SET_GET_BILL_HISTORY_LOADING:
      return {
        ...state,
        isGetBillHistoryLoading: payload,
      };

    case GET_BILL_HISTORY_SUCCESS:
      return {
        ...state,
        billHistoryData: payload.data || [],
        totalRecords: payload.pagination?.totalRecords || 0,
        currentPage: payload.pagination?.currentPage || 1,
        itemsPerPage: payload.pagination?.itemsPerPage || 10,
        totalPages: payload.pagination?.totalPages || 0,
        hasNextPage: payload.pagination?.hasNextPage || false,
        hasPreviousPage: payload.pagination?.hasPreviousPage || false,
        startRecord: payload.pagination?.startRecord || 0,
        endRecord: payload.pagination?.endRecord || 0,
        isGetBillHistorySuccess: true,
        isGetBillHistoryError: false,
        getBillHistoryError: null,
      };

    case GET_BILL_HISTORY_FAIL:
      return {
        ...state,
        isGetBillHistorySuccess: false,
        isGetBillHistoryError: true,
        getBillHistoryError: payload,
        billHistoryData: [],
        currentPage: 1,
        itemsPerPage: 10,
        totalRecords: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false,
        startRecord: 0,
        endRecord: 0,
      };

    case SET_GET_SINGLE_BILL_DATA_LOADING:
      return {
        ...state,
        isSingleBillDataLoading: payload,
      };

    case GET_SINGLE_BILL_DATA_SUCCESS:
      return {
        ...state,
        singleBillData: payload,
        isSingleBillDataSuccess: true,
        isSingleBillDataError: false,
        getSingleBillDataError: null,
      };

    case GET_SINGLE_BILL_DATA_FAIL:
      return {
        ...state,
        singleBillData: null,
        isSingleBillDataSuccess: false,
        isSingleBillDataError: true,
        getSingleBillDataError: payload,
      };

    default:
      return state;
  }
}
